function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NotificationInstance } from '../../hooks/notification';
import { Notification } from './Notification';
import { getAnimationConfig } from './animation';
var DEFAULT_SPACE = 20;
var instance = new NotificationInstance({
  Component: Notification,
  space: DEFAULT_SPACE,
  placement: {
    'top-left': {
      horizontal: 'left',
      left: DEFAULT_SPACE,
      vertical: 'top',
      top: DEFAULT_SPACE
    },
    'top-right': {
      horizontal: 'right',
      right: DEFAULT_SPACE,
      vertical: 'top',
      top: DEFAULT_SPACE
    },
    'bottom-left': {
      horizontal: 'left',
      left: DEFAULT_SPACE,
      vertical: 'bottom'
    },
    'bottom-right': {
      horizontal: 'right',
      right: DEFAULT_SPACE,
      vertical: 'bottom'
    }
  },
  animation: {
    'top-left': getAnimationConfig(DEFAULT_SPACE, 'top-left'),
    'top-right': getAnimationConfig(DEFAULT_SPACE, 'top-right'),
    'bottom-left': getAnimationConfig(DEFAULT_SPACE, 'bottom-left'),
    'bottom-right': getAnimationConfig(DEFAULT_SPACE, 'bottom-right')
  }
});
export var notification = {
  success: function success(description) {
    if (typeof description === 'string') {
      return notification.open({
        description: description,
        type: 'success'
      });
    }

    return notification.open(_objectSpread(_objectSpread({}, description), {}, {
      type: 'success'
    }));
  },
  error: function error(description) {
    if (typeof description === 'string') {
      return notification.open({
        description: description,
        type: 'error'
      });
    }

    return notification.open(_objectSpread(_objectSpread({}, description), {}, {
      type: 'error'
    }));
  },
  info: function info(description) {
    if (typeof description === 'string') {
      return notification.open({
        description: description,
        type: 'info'
      });
    }

    return notification.open(_objectSpread(_objectSpread({}, description), {}, {
      type: 'info'
    }));
  },
  warning: function warning(description) {
    if (typeof description === 'string') {
      return notification.open({
        description: description,
        type: 'warning'
      });
    }

    return notification.open(_objectSpread(_objectSpread({}, description), {}, {
      type: 'warning'
    }));
  },
  open: function open(conf) {
    var _conf$placement = conf.placement,
        placement = _conf$placement === void 0 ? 'top-right' : _conf$placement,
        _conf$duration = conf.duration,
        duration = _conf$duration === void 0 ? 3 : _conf$duration,
        key = conf.key,
        extra = _objectWithoutProperties(conf, ["placement", "duration", "key"]);

    return instance.open(_objectSpread(_objectSpread({}, extra), {}, {
      shadow: true
    }), placement, duration, key);
  },
  close: function close(key) {
    instance.close(key);
  },
  closeAll: function closeAll(filter) {
    instance.notices.forEach(function (item) {
      var options = _objectSpread(_objectSpread({}, item.options), {}, {
        placement: item.placement,
        duration: item.duration,
        key: item.key
      });

      if (!filter || filter(options)) {
        instance.close(item.key);
      }
    });
  }
};
export { Notification };